import { EMPTY_MESSAGES } from '@/constants/admin';
import { FilterType } from '@/types/admin/messages';

export const getFilterEmptyState = (filterType: FilterType) => {
  if (filterType === 'archived') return EMPTY_MESSAGES.messages.archived;
  if (filterType === 'open') return EMPTY_MESSAGES.messages.open;
  if (filterType === 'assigned') return EMPTY_MESSAGES.messages.inbox;
  return EMPTY_MESSAGES.messages.default;
};

export const getNoResultsState = (searchQuery: string) => {
  return EMPTY_MESSAGES.messages.noResults(searchQuery);
};


